import { FinraBrokerCheckBrokerType } from 'dashboard/models/report/finra-broker-check';
import { assertNever } from 'lib/utils/types';

export default function displayBrokerType(value?: FinraBrokerCheckBrokerType): string | null {
  if (!value) {
    return null;
  }

  switch (value) {
    case FinraBrokerCheckBrokerType.Individual: {
      return 'Individual';
    }
    case FinraBrokerCheckBrokerType.Firm: {
      return 'Firm';
    }
    default:
      assertNever(value);
  }
}
